/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {Button, Container, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import {accounting} from 'accounting'
import Page from '../Pagination/Pagination'
import HeaderTable from '../../Component/BaseComponent/HeaderTable'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalaali'
import $ from 'jquery'
import {message} from 'antd'
import JASPERREPORT from '../BaseComponent/JASPERREPORT'
import cookie from 'react-cookies'
import REPORT_RETAIL from '../../Component/BaseComponent/REPORTRETAIL'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import FromToPicker from '../BaseComponent/FromToPicker'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import SearchableCombo from '../BaseComponent/searchableCombo'
import Select from 'react-select'
import SearchProduct from '../BaseComponent/SearchProduct'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import Loader from '../loaders/loader'
import {voip} from './call/voip'
import {productShop} from '../../lib/path'
import AutoComplete from '../BaseComponent/autocomplete'

class SubBaskets extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      baskets: [],
      lengthbaskets: 0,
      Drivers: [],
      tasvie: '',
      state: '',
      printInfo: [],
      providers: [],
      fromDate: '',
      toDate: '',
      proText: '',
      proFinalText: '',
      // aggregation:{}
      // ,
      buttonClicked: false,
      itemInfo: {},
      fromRegDate: '',
      toRegDate: '',
      timesInterval: [],
      arrayOfStocks: [],
      finalStocks: [],
      selectedStockProductIds: [],
      unitArr: [],
      providerArr: [],
      providerId: ''
    }
  }

  componentDidMount() {
    http.get(`public/base/type/timeIntervals`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          timesInterval: response.data.object
        })
      }
    })

    http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_UNIT}`, {}).then((response) => {
      if (response.data.error == null) {
        var unit = response.data.object
        for (let i = 0; i < unit.length; i++) {
          unit[i]['value'] = unit[i].id
          unit[i]['label'] = unit[i].title
        }

        this.setState({
          unit: response.data.object
        })
      } else {
        this.setState({
          unit: []
        })
      }
    })

    http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          var drivers = response.data.object
          for (let i = 0; i < drivers.length; i++) {
            drivers[i]['value'] = drivers[i].personId
            drivers[i]['label'] = drivers[i].personId + ' - ' + drivers[i].name
          }

          this.setState({
            Drivers: response.data.object
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })

    // http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {}).then((response) => {

    //     if (response.data.error == null) {

    //         var result = response.data.object;
    //         for (let i = 0; i < result.length; i++) {
    //             result[i]['value'] = result[i].providerId;
    //             result[i]['label'] =result[i].providerId +' - '+ result[i].title;
    //         }

    //         this.setState({
    //             providers: response.data.object
    //         })
    //     }
    //     else{
    //         // message.error(response.data.description)
    //         this.setState({
    //             providers: []
    //         })
    //     }
    //     // alert(JSON.stringify(response.data))
    // }).catch((error) => {
    //     alert(JSON.stringify(error))
    // });

    sessionStorage.removeItem('params')

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
  }

  getValueDriver = (driverId) => {
    this.setState({
      driverId
    })
  }

  onResultFetched(data) {
    this.setState({
      baskets: data
    })
  }

  changeDropDown(data) {
    this.setState({
      baskets: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  getStocks = (arrayOfStocks) => {
    var stockArr = []

    this.setState({
      arrayOfStocks
    })

    if (arrayOfStocks.length == '0') {
      this.setState({
        finalStocks: []
      })
    } else {
      for (let prop of arrayOfStocks) {
        stockArr.push(prop.value)
        this.setState({
          finalStocks: stockArr
        })
      }
    }
  }

  finalStocks = (finalStocks) => {
    let array = []
    finalStocks.forEach((item) => {
      array.push(item.stockProductId)
    })
    this.setState({
      finalStocks: array
    })
  }

  changeField(e) {
    let target = e.target
    let value = target.value

    this.setState({
      tasvie: value == '' ? '' : Number(value)
    })
  }

  changeState(e) {
    let target = e.target
    let value = target.value

    this.setState({
      state: value
    })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  changeShift(e) {
    let target = e.target

    this.setState({
      shift: target.options[target.selectedIndex].text
    })
  }

  filter() {
    let {loading} = this.state

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    let {providerArr, unitArr, finalStocks, providerId} = this.state
    let minDate = this.state.fromDate
    let maxDate = this.state.toDate
    let fromRegDate = this.state.fromRegDate
    let toRegDate = this.state.toRegDate
    let planTimeType = document.getElementById('planTimeType').value
    let timeStart = ''
    let timeEnd = ''
    if (planTimeType !== '') {
      let find = this.state.timesInterval.find((item) => +item.timeIntervalId === +planTimeType)
      if (find) {
        timeStart = find.timeStart
        timeEnd = find.timeEnd
      }
    }
    // timesInterval
    let invoiceNum = this.convertDigit(document.getElementById('invoiceNum').value.trim())
    let invoiceId = this.convertDigit(document.getElementById('invoiceId').value.trim())
    let buyerName = document.getElementById('buyerName').value
    let userCode = document.getElementById('userCode').value.trim()
    let nationalId = document.getElementById('nationalId').value.trim()
    let mobile = document.getElementById('mobile').value
    let recipientName = document.getElementById('recipientName').value
    let paid = document.getElementById('paid').value
    let confirmed = document.getElementById('confirmed').value
    let canceled = document.getElementById('canceled').value
    let payOnDelivery = document.getElementById('payOnDelivery').value
    let driverId = this.state.driverId == null || this.state.driverId == '' ? '' : this.state.driverId.personId
    let payableAmountMin = this.convertDigit(document.getElementById('payableAmountMin').value.trim())
    let payableAmountMax = this.convertDigit(document.getElementById('payableAmountMax').value.trim())
    let lastState = document.getElementById('lastState').value
    if (
      canceled === '' &&
      confirmed === '' &&
      nationalId === '' &&
      fromRegDate === '' &&
      toRegDate === '' &&
      mobile === '' &&
      finalStocks.length === 0 &&
      planTimeType == '' &&
      userCode == '' &&
      driverId == '' &&
      payableAmountMax == '' &&
      payableAmountMin == '' &&
      lastState == '' &&
      minDate == '' &&
      maxDate == '' &&
      invoiceNum == '' &&
      invoiceId == '' &&
      buyerName == '' &&
      recipientName == '' &&
      paid == '' &&
      payOnDelivery == ''
    ) {
      message.error('حداقل یک فیلتر وارد شود')
    } else if (minDate === '' || maxDate === '') {
      message.error('هر دو تاریخ تحویل وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ تحویل ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ تحویل انتها صحیح نیست')
    } else if ((fromRegDate != '' || fromRegDate == null) && isNaN(fromRegDate)) {
      message.error('فرمت تاریخ ثبت ابتدا صحیح نیست')
    } else if ((toRegDate != '' || toRegDate == null) && isNaN(toRegDate)) {
      message.error('فرمت تاریخ ثبت انتها صحیح نیست')
    } else if (mobile != '' && !mobile.match(/^09\d{9}$/g)) {
      message.error('موبایل را صحیح وارد کنید')
    } else {
      this.setState({
        toPrintDate: minDate == '' ? '-' : jMoment(this.state.fromDate).format('jYY/jMM/jDD'),
        fromPrintDate: maxDate == '' ? '-' : jMoment(this.state.toDate).format('jYY/jMM/jDD'),
        loading: true
      })

      sessionStorage.setItem(
        'params',
        `timestart=${timeStart}&timeend=${timeEnd}&canceled=${canceled}&confirmed=${confirmed}&registerDateMin=${
          fromRegDate == '' ? '' : fromRegDate
        }&registerDateMax=${
          toRegDate == '' ? '' : toRegDate
        }&userNationalId=${nationalId}&userCode=${userCode}&mobile=${mobile}&timeIntervalId=${planTimeType}&planDateMin=${
          minDate == '' ? '' : minDate
        }&planDateMax=${
          maxDate == '' ? '' : maxDate
        }&invoiceNum=${invoiceNum}&invoiceId=${invoiceId}&buyerName=${buyerName}&recipientName=${recipientName}&paid=${paid}&payOnDelivery=${payOnDelivery}&driverId=${driverId}&payableAmountMin=${payableAmountMin}&payableAmountMax=${payableAmountMax}&lastState=${lastState}&providerIds=${providerId}&productUnitIds=${unitArr}&stockProductIds=${finalStocks}`
      )
      http
        .get(
          `${
            REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_COMPLETE
          }?export=false&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`,
          {}
        )
        .then((response) => {
          if (response.data.error == null) {
            console.log(response.data)

            $('.showBaseTable,.print').fadeIn()

            sessionStorage.setItem('countAll', response.data.object.countAll)
            this.setState({
              baskets: response.data.object.result,
              lengthbaskets: response.data.object.countAll,
              proFinalText: this.state.proText,
              buttonClicked: true,
              loading: false
            })
          } else {
            message.error(response.data.description)

            $('.showBaseTable,.print').fadeOut()
            this.setState({
              loading: false
            })
            // message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  groupPrint = () => {
    let {providerArr, unitArr, finalStocks, loading, providerId} = this.state
    let minDate = this.state.fromDate
    let maxDate = this.state.toDate
    let fromRegDate = this.state.fromRegDate
    let toRegDate = this.state.toRegDate
    let planTimeType = document.getElementById('planTimeType').value

    let timeStart = ''
    let timeEnd = ''
    if (planTimeType !== '') {
      let find = this.state.timesInterval.find((item) => +item.timeIntervalId === +planTimeType)
      if (find) {
        timeStart = find.timeStart
        timeEnd = find.timeEnd
      }
    }

    let invoiceNum = this.convertDigit(document.getElementById('invoiceNum').value.trim())
    let invoiceId = this.convertDigit(document.getElementById('invoiceId').value.trim())
    let buyerName = document.getElementById('buyerName').value
    let userCode = document.getElementById('userCode').value.trim()
    let nationalId = document.getElementById('nationalId').value.trim()
    let mobile = document.getElementById('mobile').value
    let recipientName = document.getElementById('recipientName').value
    let paid = document.getElementById('paid').value
    let confirmed = document.getElementById('confirmed').value
    let canceled = document.getElementById('canceled').value
    let payOnDelivery = document.getElementById('payOnDelivery').value
    let driverId = this.state.driverId == null || this.state.driverId == '' ? '' : this.state.driverId.personId
    let payableAmountMin = this.convertDigit(document.getElementById('payableAmountMin').value.trim())
    let payableAmountMax = this.convertDigit(document.getElementById('payableAmountMax').value.trim())
    let lastState = document.getElementById('lastState').value
    if (
      canceled === '' &&
      confirmed === '' &&
      nationalId === '' &&
      fromRegDate === '' &&
      toRegDate === '' &&
      mobile === '' &&
      finalStocks.length === 0 &&
      planTimeType == '' &&
      userCode == '' &&
      driverId == '' &&
      payableAmountMax == '' &&
      payableAmountMin == '' &&
      lastState == '' &&
      minDate == '' &&
      maxDate == '' &&
      invoiceNum == '' &&
      invoiceId == '' &&
      buyerName == '' &&
      recipientName == '' &&
      paid == '' &&
      payOnDelivery == ''
    ) {
      message.error('حداقل یک فیلتر وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ تحویل ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ تحویل انتها صحیح نیست')
    } else if ((fromRegDate != '' || fromRegDate == null) && isNaN(fromRegDate)) {
      message.error('فرمت تاریخ ثبت ابتدا صحیح نیست')
    } else if ((toRegDate != '' || toRegDate == null) && isNaN(toRegDate)) {
      message.error('فرمت تاریخ ثبت انتها صحیح نیست')
    } else if (mobile != '' && !mobile.match(/^09\d{9}$/g)) {
      message.error('موبایل را صحیح وارد کنید')
    } else {
      let params = `timestart=${timeStart}&timeend=${timeEnd}&canceled=${canceled}&confirmed=${confirmed}&registerDateMin=${
        fromRegDate == '' ? '' : fromRegDate
      }&registerDateMax=${
        toRegDate == '' ? '' : toRegDate
      }&userNationalId=${nationalId}&userCode=${userCode}&mobile=${mobile}&timeIntervalId=${planTimeType}&planDateMin=${
        minDate == '' ? '' : minDate
      }&planDateMax=${
        maxDate == '' ? '' : maxDate
      }&invoiceNum=${invoiceNum}&invoiceId=${invoiceId}&buyerName=${buyerName}&recipientName=${recipientName}&paid=${paid}&payOnDelivery=${payOnDelivery}&driverId=${driverId}&payableAmountMin=${payableAmountMin}&payableAmountMax=${payableAmountMax}&lastState=${lastState}&providerIds=${providerId}&productUnitIds=${unitArr}&stockProductIds=${finalStocks}`
      JASPERREPORT(`report/jasper/deliveryPack/detail/complete?${params}`)
    }
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  handleChangeFromRegDate = (fromRegDate) => {
    this.setState({
      fromRegDate
    })
  }

  handleChangeToRegDate = (toRegDate) => {
    this.setState({
      toRegDate
    })
  }

  exportExcel = () => {
    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_COMPLETE
        }?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['planDate'] = jMoment(excelReport[i]['planDate']).format('jYY/jMM/jDD')
            excelReport[i]['bazeTahvil'] =
              excelReport[i]['planTimeFrom'].substr(0, 5) + ' - ' + excelReport[i]['planTimeTo'].substr(0, 5)

            if (excelReport[i].invoice['mobile'] == null) {
              excelReport[i].invoice['mobile'] = '-'
            } else {
              excelReport[i].invoice['mobile'] = excelReport[i].invoice['mobile'].replace(/\+98/g, '0')
            }

            if (excelReport[i].invoice['paid']) {
              excelReport[i].invoice['paid'] = 'پرداخت شده'
            } else {
              excelReport[i].invoice['paid'] = 'پرداخت نشده'
            }
            if (excelReport[i].invoice['canceled']) {
              excelReport[i].invoice['canceled'] = 'کنسل شده'
            } else {
              excelReport[i].invoice['canceled'] = 'کنسل نشده'
            }

            if (excelReport[i].invoice['payOnDelivery']) {
              excelReport[i].invoice['payOnDelivery'] = 'بله'
            } else {
              excelReport[i].invoice['payOnDelivery'] = 'خیر'
            }

            if (excelReport[i].invoice['confirmed']) {
              excelReport[i].invoice['confirmed'] = 'بله'
            } else {
              excelReport[i].invoice['confirmed'] = 'خیر'
            }
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  getPrintInfo = () => {
    let {loading} = this.state
    this.setState({
      loading: true
    })
    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_COMPLETE
        }?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          console.log(response.data)

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            printInfo: response.data.object.result,
            // aggregation:response.data.object.aggregation
            // ,
            loading: false
          })
        } else {
          this.setState({
            loading: false
          })
          // message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 landscape;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  handleChangeUnit = (multiUnit) => {
    var unitArr = []
    this.setState({multiUnit})
    // alert(multiUnit.length)
    if (multiUnit.length == '0') {
      this.setState({
        unitArr: []
      })
    } else {
      for (let prop of multiUnit) {
        unitArr.push(prop.id)
        this.setState({
          unitArr: unitArr
        })
      }
    }
  }

  handleChangeProvider = (multiProvider) => {
    var providerArr = []
    this.setState({multiProvider})
    if (multiProvider.length == '0') {
      this.setState({
        providerArr: []
      })
    } else {
      for (let prop of multiProvider) {
        providerArr.push(prop.providerId)
        this.setState({
          providerArr: providerArr
        })
      }
    }
  }

  callToCustomer = (mobile, buyerName) => {
    if (mobile === '') {
      message.error('شماره موبایل مورد نظر وجود ندارد')
    } else {
      this.setState({
        showMobileCallModal: true
      })
      let internalPhone = '725'
      voip(mobile, buyerName)
        .then(() => {
          message.success('تماس برقرار شد لطفا منتظر پاسخ بمانید')
        })
        .catch((err) => {
          message.error(err)
        })
    }
  }

  render() {
    const {lengthbaskets, loading} = this.state
    let pageNumber = sessionStorage.getItem('pageNumber')
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    var params = sessionStorage.getItem('params')
    let reporterName = cookie.load('name')
    let printCol = [
      'ردیف',
      'تاریخ تحویل',
      'بازه تحویل',
      'شناسه فاکتور',
      'شماره فاکتور',
      ' خریدار',
      ' تحویل گیرنده',
      'موبایل',
      'پرداخت',
      'تایید',
      'پرداخت در محل',
      'قابل پرداخت',
      'کد محصول',
      'نام محصول',
      'نام تامین کننده',
      'تعداد',
      'واحد',
      'قیمت واحد',
      'قیمت کل',
      'تخفیف سایت',
      'تخفیف تامین کننده',
      'قابل پرداخت'
    ]

    let excelColumns = [
      {title: 'نام خریدار', value: 'buyerName'},
      {title: 'نام تحویل گیرنده', value: 'recipientName'},
      {title: 'ادرس', value: 'address'},
      {title: 'موبایل', value: 'mobile'},
      {title: 'تلفن', value: 'phone'},
      {title: 'شیوه ارسال', value: 'deliveryMethodTitle'}
    ]

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />

        <div className="printSection">
          <table className="printTable printReportTable lanscapeTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="لیست گزارشات ریز پارت تحویل"
              reporter={reporterName}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              headerColSpan={22}
              rightColSpan={10}
              centerColSpan={1}
              leftColSpan={11}
              centerSection={''}
              rightSection={'تاریخ ثبت از : ' + this.state.toPrintDate + ' تا ' + this.state.fromPrintDate}
              columns={printCol}
            />

            <tbody>
              {this.state.printInfo.map((items, index) => (
                <tr key={'i' + index} style={index % 2 == 0 ? {backgroundColor: '#f1f1f1'} : {backgroundColor: '#fff'}}>
                  <td>{index + 1}</td>
                  <td>{jMoment(items.planDate).format('jYYYY/jM/jD')}</td>
                  <td>{items.planTimeFrom.substr(0, 5) + ' - ' + items.planTimeTo.substr(0, 5)}</td>
                  <td>{items.invoice.invoiceId}</td>
                  <td>{items.invoice.invoiceNum}</td>
                  <td>{items.invoice.buyerName}</td>
                  <td>{items.invoice.recipientName}</td>
                  {/*<td>{items.invoice.address}</td>*/}
                  <td className="mobileTD">
                    {items.invoice.mobile == null ? '-' : items.invoice.mobile.replace(/\+98/g, '0')}
                  </td>
                  <td className="smallPhoto">{items.invoice.paid ? 'بله' : 'خیر'}</td>
                  <td className="smallPhoto">{items.invoice.confirmed ? 'بله' : 'خیر'}</td>
                  <td>{items.invoice.payOnDelivery ? 'بله' : 'خیر'}</td>
                  {/*<td className='priceCell'>{accounting.formatMoney(items.totalInfo.totalAmount, '', ',')}</td>*/}
                  {/*<td className='priceCell'>{accounting.formatMoney(items.totalInfo.discountAmount, '', ',')}</td>*/}
                  <td className="priceCell">{accounting.formatMoney(items.totalInfo.payableAmount, '', ',')}</td>
                  <td>{items.item.articleId}</td>
                  <td>{items.item.productName}</td>
                  <td>{items.item.providerName}</td>
                  <td>{items.item.quantity}</td>
                  <td>{items.item.productUnitTitle}</td>
                  <td className="priceCell">{accounting.formatMoney(items.item.unitPrice, '', ',')}</td>
                  <td className="priceCell">{accounting.formatMoney(items.item.totalAmount, '', ',')}</td>
                  <td className="priceCell">
                    {accounting.formatMoney(Number(items.item.websiteDiscountAmount), '', ',')}
                  </td>
                  <td className="priceCell">
                    {accounting.formatMoney(Number(items.item.providerDiscountAmount), '', ',')}
                  </td>
                  <td className="priceCell">{accounting.formatMoney(items.item.payableAmount, '', ',')}</td>
                </tr>
              ))}
              {/*<tr>*/}
              {/*    <td colSpan={12}>مجموع</td>*/}
              {/*    <td colSpan={3}></td>*/}
              {/*    <td colSpan={1}>{this.state.itemInfo.quantity}</td>*/}
              {/*    <td colSpan={1}></td>*/}
              {/*    <td colSpan={1} className='priceCell'>{accounting.formatMoney( this.state.itemInfo.unitPrice ,'',',')}</td>*/}
              {/*    <td colSpan={1} className='priceCell'>{accounting.formatMoney( this.state.itemInfo.totalAmount,'',',')}</td>*/}
              {/*    <td className='priceCell'>{accounting.formatMoney(this.state.itemInfo.websiteDiscountAmount,'',',')}</td>*/}
              {/*    <td className='priceCell'>{accounting.formatMoney(this.state.itemInfo.providerDiscountAmount ,'',',')}</td>*/}
              {/*    <td colSpan={1} className='priceCell'>{accounting.formatMoney(this.state.itemInfo.payableAmount,'',',')}</td>*/}
              {/*</tr>*/}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش ریز پارت تحویل.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'planDate'}
                field={'planDate'}
                title={'تاریخ تحویل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'bazeTahvil'}
                field={'bazeTahvil'}
                title={'بازه تحویل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'invoiceId'}
                field={'invoice.invoiceId'}
                title={'شناسه فاکتور'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'invoiceNum'}
                field={'invoice.invoiceNum'}
                title={'شماره فاکتور'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'buyerName'}
                field={'invoice.buyerName'}
                title={'نام خریدار'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'userCode'}
                field={'customer.userCode'}
                title={'کد مشتری'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'nationalId'}
                field={'customer.nationalId'}
                title={'کد ملی'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'recipientName'}
                field={'invoice.recipientName'}
                title={'تحویل گیرنده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'mobile'}
                field={'invoice.mobile'}
                title={'موبایل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'paid'}
                field={'invoice.paid'}
                title={'وضعیت پرداخت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'confirmed'}
                field={'invoice.confirmed'}
                title={'تایید'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'canceled'}
                field={'invoice.canceled'}
                title={'وضعیت کنسل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'payOnDelivery'}
                field={'invoice.payOnDelivery'}
                title={'پرداخت در محل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'payableAmount'}
                field={'totalInfo.payableAmount'}
                title={'قابل پرداخت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'payableAmount'}
                field={'item.articleId'}
                title={'کد محصول'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'productName'}
                field={'item.productName'}
                title={'نام محصول'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'providerName'}
                field={'item.providerName'}
                title={'تامین کننده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'quantity'}
                field={'item.quantity'}
                title={'تعداد'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'productUnitTitle'}
                field={'item.productUnitTitle'}
                title={'واحد شمارش'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'unitPrice'}
                field={'item.unitPrice'}
                title={'قیمت واحد'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'totalAmount'}
                field={'item.totalAmount'}
                title={'قیمت کل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'websiteDiscountAmount'}
                field={'item.websiteDiscountAmount'}
                title={'تخفیف سایت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'providerDiscountAmount'}
                field={'item.providerDiscountAmount'}
                title={'تخفیف تامین کننده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'fpayableAmount'}
                field={'item.payableAmount'}
                title={'قابل پرداخت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>ریز پارت تحویل</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl=""
                  url={REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_COMPLETE}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printUrl="printBaskets"
                  printLink=""
                  printComponent={this.printTable}
                  execelUrl={REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_COMPLETE + '?export=true'}
                  excelColumns={excelColumns}
                  titleAdd="افزودن شهر"
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
                <button className="printButton jasperBtn" onClick={this.groupPrint}>
                  چاپ گروهی
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ تحویل از"
                  toLabel="تاریخ تحویل تا"
                  defaulValue={true}
                  fromId="from"
                  toId="to"
                  force
                />

                <FromToPicker
                  onChangeFromDate={this.handleChangeFromRegDate}
                  onChangeToDate={this.handleChangeToRegDate}
                  fromLabel="تاریخ ثبت از"
                  toLabel="تاریخ ثبت تا"
                  defaulValue={false}
                  fromId="fromReg"
                  toId="toReg"
                />

                <div className="formComponent">
                  <label>شیفت زمانی :</label>
                  <select className="form-control" onChange={this.changeShift.bind(this)} id="planTimeType">
                    <option value="">-------</option>
                    {this.state.timesInterval.map((shift, index) => (
                      <option value={shift.timeIntervalId}>{shift.timeStart + ' تا ' + shift.timeEnd}</option>
                    ))}
                  </select>
                </div>

                <div className="formComponent">
                  <label>شناسه فاکتور:</label>
                  <input
                    type="text"
                    defaultValue={this.state.invoiceId}
                    className="form-control"
                    id="invoiceId"
                    name="invoiceId"
                  />
                </div>

                <div className="formComponent">
                  <label>شماره فاکتور:</label>
                  <input type="text" className="form-control" id="invoiceNum" name="invoiceNum" />
                </div>

                <div className="formComponent">
                  <label>کد مشتری:</label>
                  <input
                    type="text"
                    defaultValue={this.state.userCode}
                    className="form-control"
                    id="userCode"
                    name="userCode"
                  />
                </div>

                <div className="formComponent">
                  <label>کد ملی مشتری:</label>
                  <input type="text" className="form-control" id="nationalId" name="nationalId" />
                </div>

                <div className="formComponent">
                  <label>موبایل (در فاکتور) : </label>
                  <input type="text" className="form-control" id="mobile" name="mobile" />
                </div>

                <div className="formComponent">
                  <label>نام خریدار (در فاکتور) :</label>
                  <input type="text" className="form-control" id="buyerName" name="buyerName" />
                </div>

                <div className="formComponent">
                  <label>نام تحویل گیرنده (در فاکتور) :</label>
                  <input type="text" className="form-control" id="recipientName" name="recipientName" />
                </div>

                <div className="formComponent">
                  <label>وضعیت تایید :</label>
                  <select className="form-control" id="confirmed" name="confirmed">
                    <option value="">-------</option>
                    <option selected={true} value={1}>
                      تایید شده
                    </option>
                    <option value={0}>تایید نشده</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>وضعیت کنسل :</label>
                  <select className="form-control" id="canceled" name="canceled">
                    <option value="">-------</option>
                    <option value={1}>کنسل شده</option>
                    <option selected={true} value={0}>
                      کنسل نشده
                    </option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>وضعیت پرداخت :</label>
                  <select className="form-control" id="paid" name="paid">
                    <option value="">-------</option>
                    <option value={1}>پرداخت شده</option>
                    <option value={0}>پرداخت نشده</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>پرداخت در محل :</label>
                  <select className="form-control" id="payOnDelivery" name="payOnDelivery">
                    <option value="">-------</option>
                    <option value={1}>بله</option>
                    <option value={0}>خیر</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>حالت:</label>
                  <select
                    className="form-control"
                    onChange={this.changeState.bind(this)}
                    id="lastState"
                    name="lastState"
                  >
                    <option value="">-------</option>
                    <option value="-100">کنسل</option>
                    <option value="-75">مرجوعی</option>
                    <option value="-50">بازگشتی</option>
                    <option value="100">تخصیص مجدد</option>
                    <option value="-1">تخصیص داده نشده</option>
                    <option value="1">فعال</option>
                    <option value="5">اول فعال</option>
                    <option value="10">شروع شده</option>
                    <option value="18">تسویه شده</option>
                  </select>
                </div>

                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.Drivers}
                    getValueCombo={this.getValueDriver}
                    lableText="رساننده"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    isDisabled={false}
                  />
                </div>

                <div className="formComponent">
                  <label>قابل پرداخت از :</label>
                  <input type="text" className="form-control" id="payableAmountMin" name="payableAmountMin" />
                </div>

                <div className="formComponent">
                  <label>قابل پرداخت تا :</label>
                  <input type="text" className="form-control" id="payableAmountMax" name="payableAmountMax" />
                </div>

                <div className="formComponent">
                  <label>واحد کالا :</label>
                  <Select
                    value={this.state.multiUnit}
                    onChange={this.handleChangeUnit}
                    options={this.state.unit}
                    isMulti={true}
                    isClearable={true}
                    placeholder=""
                  />
                </div>

                <div className="formComponent selectComponent">
                  <AutoComplete
                    label="تامین کننده"
                    api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                    textField="title"
                    valueField="providerId"
                    id="provider"
                    value={this.state.providerId}
                    setValue={(providerId) => this.setState({providerId})}
                  />
                  {/* <label>تامین کننده ها :</label>
                                    <Select
                                        value={this.state.multiProvider}
                                        onChange={this.handleChangeProvider}
                                        options={this.state.providers}
                                        isMulti={true}
                                        isClearable={true}
                                        placeholder=''
                                    /> */}
                </div>
              </div>
              <div>
                {this.state.providers.length ? (
                  <SearchProduct
                    getStocks={this.getStocks}
                    finalStocks={this.finalStocks}
                    providers={this.state.providers}
                  />
                ) : null}
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
              <p className="errorText" id="errorText" />
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td rowSpan={2}>ردیف</td>
                    <td colSpan={11}>پارت تحویل</td>
                    <td colSpan={10}>جزییات</td>
                  </tr>

                  <tr className="firstRow">
                    <td>تاریخ تحویل</td>
                    <td>بازه تحویل</td>
                    <td>شناسه فاکتور</td>
                    <td>شماره فاکتور</td>
                    <td>نام خریدار</td>
                    <td>نام تحویل گیرنده</td>
                    {/*<td>آدرس</td>*/}
                    <td>موبایل</td>
                    <td>وضعیت پرداخت</td>
                    <td>وضعیت تایید</td>
                    <td>پرداخت در محل</td>
                    <td className="priceCell">قابل پرداخت</td>
                    <td>کد محصول</td>
                    <td>نام محصول</td>
                    <td>نام تامین کننده</td>
                    <td>تعداد</td>
                    <td>واحد شمارش</td>
                    <td className="priceCell">قیمت واحد</td>
                    <td className="priceCell">قیمت کل</td>
                    <td className="priceCell">تخفیف سایت</td>
                    <td className="priceCell">تخفیف تامین کننده</td>
                    <td className="priceCell">قابل پرداخت</td>
                  </tr>
                  {this.state.baskets.map((items, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                      <td>{jMoment(items.planDate).format('jYYYY/jM/jD')}</td>
                      <td>{items.planTimeFrom.substr(0, 5) + ' - ' + items.planTimeTo.substr(0, 5)}</td>
                      <td>{items.invoice.invoiceId}</td>
                      <td>{items.invoice.invoiceNum}</td>
                      <td>{items.invoice.buyerName}</td>
                      <td>{items.invoice.recipientName}</td>
                      {/*<td>{items.invoice.address}</td>*/}
                      <td>
                        <button
                          title="تماس"
                          className="btn btn-sm btn-success text-dark font-weight-bold"
                          onClick={() =>
                            this.callToCustomer(
                              items.invoice.mobile == null ? '' : items.invoice.mobile.replace(/\+98/g, '0'),
                              items.invoice.buyerName
                            )
                          }
                        >
                          <span className="text-dark font-weight-bold" style={{color: '#000'}}>
                            {items.invoice.mobile == null ? '-' : items.invoice.mobile.replace(/\+98/g, '0')}
                          </span>
                        </button>
                      </td>
                      <td className="smallPhoto">
                        {items.invoice.paid ? (
                          <img src={require('../../image/confirm.svg')} />
                        ) : (
                          <img src={require('../../image/ignor.svg')} />
                        )}
                      </td>
                      <td className="smallPhoto">
                        {items.invoice.confirmed ? (
                          <img src={require('../../image/confirm.svg')} />
                        ) : (
                          <img src={require('../../image/ignor.svg')} />
                        )}
                      </td>
                      <td>{items.invoice.payOnDelivery ? 'بله' : 'خیر'}</td>
                      <td className="priceCell">{accounting.formatMoney(items.totalInfo.payableAmount, '', ',')}</td>
                      <td>{items.item.articleId}</td>
                      <td>
                        <a target="_blank" href={productShop({articleId: items.item.articleId})}>
                          {items.item.productName}
                        </a>
                      </td>
                      <td>{items.item.providerName}</td>
                      <td>{items.item.quantity}</td>
                      <td>{items.item.productUnitTitle}</td>
                      <td className="priceCell">{accounting.formatMoney(items.item.unitPrice, '', ',')}</td>
                      <td className="priceCell">{accounting.formatMoney(items.item.totalAmount, '', ',')}</td>
                      <td className="priceCell">
                        {accounting.formatMoney(Number(items.item.websiteDiscountAmount), '', ',')}
                      </td>
                      <td className="priceCell">
                        {accounting.formatMoney(Number(items.item.providerDiscountAmount), '', ',')}
                      </td>
                      <td className="priceCell">{accounting.formatMoney(items.item.payableAmount, '', ',')}</td>
                    </tr>
                  ))}
                  {/*<tr>*/}
                  {/*    <td colSpan={12}>مجموع</td>*/}
                  {/*    <td colSpan={3}></td>*/}
                  {/*    <td colSpan={1}>{this.state.itemInfo.quantity}</td>*/}
                  {/*    <td colSpan={1}></td>*/}
                  {/*    <td colSpan={1} className='priceCell'>{accounting.formatMoney( this.state.itemInfo.unitPrice ,'',',')}</td>*/}
                  {/*    <td colSpan={1} className='priceCell'>{accounting.formatMoney( this.state.itemInfo.totalAmount,'',',')}</td>*/}
                  {/*    <td className='priceCell'>{accounting.formatMoney(this.state.itemInfo.websiteDiscountAmount,'',',')}</td>*/}
                  {/*    <td className='priceCell'>{accounting.formatMoney(this.state.itemInfo.providerDiscountAmount ,'',',')}</td>*/}
                  {/*    <td colSpan={1} className='priceCell'>{accounting.formatMoney(this.state.itemInfo.payableAmount,'',',')}</td>*/}
                  {/*</tr>*/}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={lengthbaskets}
                  onResultFetched={this.onResultFetched.bind(this)}
                  url={REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_COMPLETE}
                  urlParams={params + '&sortBy='}
                />
              </div>
            </div>
          </div>
          <div style={{width: '100%', height: '50px'}} />
        </div>
        <Modal isOpen={this.state.showMobileCallModal} toggle={() => this.setState({showMobileCallModal: false})}>
          <ModalBody className="d-flex flex-column justify-content-center align-content-center align-items-center">
            <h3 className="font-weight-bold">تماس با کاربر برقرار شد</h3>
            <button className="btn btn-success" onClick={() => this.setState({showMobileCallModal: false})}>
              بستن
            </button>
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

export default SubBaskets
